export const DAY_OPTIONS = [1, 3, 7, 14, 30] as const;

/** "5m ago", "3h ago", "2d ago"; "in 4h" for future times. */
export const relative = (iso: string | null | undefined): string => {
  if (!iso) return "—";
  const diff = new Date(iso).getTime() - Date.now();
  const minutes = Math.round(Math.abs(diff) / 60_000);
  if (minutes < 1) return "now";
  const text = formatMinutes(minutes);
  return diff < 0 ? `${text} ago` : `in ${text}`;
};

export const formatMinutes = (minutes: number | null): string => {
  if (minutes === null) return "—";
  if (minutes < 60) return `${Math.round(minutes).toString()}m`;
  if (minutes < 48 * 60) return `${Math.round(minutes / 60).toString()}h`;
  return `${Math.round(minutes / 1440).toString()}d`;
};

/** Minutes between two ISO times, e.g. how long a held message waited. */
export const minutesBetween = (fromIso: string, toIso: string): number =>
  Math.max(0, (new Date(toIso).getTime() - new Date(fromIso).getTime()) / 60_000);
